import React, { Component } from "react";
import "./MenuBar.css";
import packageInfo from '../../package.json'
import { localestr } from "../utils.js";
import icons from "../icons.svg";
import Menu from "./menu.js";

function MenuItems(Data, Visibility, Level, NewWindow, consts, urAdmin, rights, hidden) {
    const items = Data.map(function (item) {
        if (item.visibility) {
            if (consts && parseInt(consts[item.visibility] || 0) === 0) return null;
        }
        if (!urAdmin && !rights[item.wndType]) return null;
        if (item.isGroup) {
            return (
                <MenuGroup
                    key={item.id}
                    item={item}
                    level={Level}
                    NewWindow={NewWindow}
                    consts={consts}
                    urAdmin={urAdmin}
                    rights={rights}
                    hidden={hidden}
                />
            );
        } else {
            let icon = null;
            if (item.icon) icon = <img className="menu_img" src={icons + "#" + item.icon} alt="" />;
            return (
                <li
                    tabIndex="0"
                    key={item.id}
                    className={"item" + Level}
                    onKeyUp={(e) => {
                        if (e.key === "Enter") NewWindow(item.wndType, item.caption, "", item.multytab);
                    }}
                    onClick={() => {
                        NewWindow(item.wndType, item.caption, "", item.multytab);
                    }}
                >
                    {icon}
                    {localestr(item.caption)}
                </li>
            );
        }
    });
    const styles = {
        visibility: Visibility ? "visible" : "hidden",
        display: Visibility ? "block" : "none",
    };
    return <ul style={styles}>{items}</ul>;
}

class MenuGroup extends Component {
    state = {
        opened: false,
    };

    handleClick = () => {
        this.setState(({ opened }) => ({ opened: !opened }));
    };

    render() {
        const item = this.props.item;
        const level = this.props.level;
        const NewWindow = this.props.NewWindow;
        const consts = this.props.consts;
        const urAdmin = this.props.urAdmin;
        const rights = this.props.rights;
        const hidden = this.props.hidden;
        let icon = null;
        if (item.icon) icon = <img className="menu_img" src={icons + "#" + item.icon} alt="" />;
        if (hidden) {
            let menuData = [];
            item.data.forEach((item) => {
                if (item.isGroup) {
                    menuData.push({
                        name: item.caption,
                        icon: `#${item.icon}`,
                        id: item.id,
                        isFolder: true,
                    });
                    item.data.forEach((item2) => {
                        if (item2.isGroup) {
                            menuData.push({
                                name: item2.caption,
                                icon: `#${item2.icon}`,
                                id: item2.id,
                                isFolder: true,
                            });
                            item2.data.forEach((item3) => {
                                menuData.push({
                                    parent: item2.id,
                                    name: item3.caption,
                                    icon: `#${item3.icon}`,
                                    action: () => {
                                        NewWindow(item3.wndType, item3.caption, "", item3.multytab);
                                    },
                                });
                            });
                        } else {
                            menuData.push({
                                parent: item.id,
                                name: item2.caption,
                                icon: `#${item2.icon}`,
                                action: () => {
                                    NewWindow(item2.wndType, item2.caption, "", item2.multytab);
                                },
                            });
                        }
                    });
                } else {
                    menuData.push({
                        name: item.caption,
                        icon: `#${item.icon}`,
                        action: () => {
                            NewWindow(item.wndType, item.caption, "", item.multytab);
                        },
                    });
                }
            });
            return (
                <li
                    tabIndex="0"
                    key={item.id}
                    className={"group" + level + "h"}
                    style={{ overflow: "visible", position: "relative" }}
                >
                    <Menu data={menuData} left={true}>
                        {icon}
                    </Menu>
                </li>
            );
        } else {
            return (
                <>
                    <li
                        tabIndex="0"
                        key={item.id}
                        className={this.state.opened ? "opened" + level : "group" + level}
                        onKeyUp={(e) => {
                            if (e.key === "Enter") this.handleClick();
                        }}
                        onClick={this.handleClick}
                    >
                        {icon}
                        {localestr(item.caption)}
                    </li>
                    {MenuItems(item.data, this.state.opened, level + 1, NewWindow, consts, urAdmin, rights, hidden)}
                </>
            );
        }
    }
}

function MenuBar({ MenuData, tabNew, hiden, showHideMenu, consts, urAdmin, rights }) {
    const items = MenuItems(MenuData, true, 0, tabNew, consts, urAdmin, rights, hiden);
    return (
        <div className={hiden ? "menuhiden no-print" : "menu no-print"}>
            <aside className="no-print" style={hiden ? { overflow: "visible" } : {}}>
                <div className='navbar no-print' style={{width:'100%',position:'relative'}} onClick={showHideMenu}>
                    <div className={hiden?'label2':'label'}></div>
                    <div style={{flexGrow:'10',fontSize:'8px',alignSelf:'end',fontWeight:'100'}}>{hiden?'':packageInfo.version}</div>
                </div>
                {items}
            </aside>
            <div className="wraper no-print">
                <div onClick={showHideMenu}>{hiden ? "»" : "«"}</div>
            </div>
        </div>
    );
}

export default MenuBar;
